import { GrFormClose } from 'react-icons/gr';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ChangeEmail from './popup-components/ChangeEmail'
import ChangePassword from './popup-components/ChangePassword'
import CustomerComplaints from './popup-components/CustomerComplaints'
import EmailAlreadyUsed from './popup-components/EmailAlreadyUsed'
import ForgotPassword from './popup-components/ForgotPassword'
import InvalidEmail from './popup-components/InvalidEmail'
import LoginMobile from './popup-components/LoginMobile'
import SecurityQuestionChange from './popup-components/SecurityQuestionChange'
import PinProtection from './popup-components/PinProtection'
import SendEmail from './popup-components/SendEmail'
import SendEmailDuration from './popup-components/SendEmailDuration'
import NewMessageNotification from './popup-components/NewMessageNotification'
import ConfirmDelete from './popup-components/ConfirmDelete'
import ProviderMaintenance from './popup-components/ProviderMaintenance'
import { useState } from 'react'
import ReferralMessage from './popup-components/ReferralMessage'
import Agree from './popup-components/Agree'
import SecurityValidation from './popup-components/SecurityValidation'
import { useEffect } from 'react'
import { useRef } from 'react'
import ErrorMessages from './popup-components/ErrorMessages'
import SuccessMessages from './popup-components/SuccessMessages'
import RegisterWithLogin from './popup-components/RegisterWithLogin'
import UserBlock from './popup-components/UserBlock'
import { useSelector } from 'react-redux'
import ExpiredPassword from './popup-components/ExpiredPassword'
import Result from './popup-components/Result'
import ProviderGameCommingSoon from './popup-components/ProviderGameCommingSoon'
import TokenValidation from './popup-components/TokenValidation'
import GlobalMaintenance from './popup-components/GlobleMaintenance'
import PreLogin from './popup-components/PreLogin'
import PostLogin from './popup-components/PostLogin'
import DepositWithdrawMessage from './popup-components/DepositWithdrawMessage'
import PlayerRejected from './popup-components/PlayerRejected';
import GameNotPlay from './popup-components/GameNotPlay';
import CompleteResult from '../complete-result/CompleteResult';
import ShowWarning from './popup-components/ShowWarning';
import ShowSuccess from './popup-components/ShowSuccess';
import HomeScreenPopup from './popup-components/HomeScreenPopup';
import LoginPopup from './popup-components/LoginPopup';
import TextReadMore from './popup-components/TextReadMore';
import Notification from './popup-components/Notification';
import Register from './popup-components/Register';
import ComingSoon from './popup-components/ComingSoon';
import RulesOfPlay from './popup-components/RulesOfPlay';
import GamePlayer from './popup-components/GamePlayer';
import NewPassword from '../../pages/authentication/NewPassword';
import ResetAdminPassword from './popup-components/ResetAdminPassword';
import ValidationMailVarification from './popup-components/ValidationMailVarification';
import LaunchGameMessage from './popup-components/LaunchGameMessage';
import ApiResponseError from './popup-components/ApiResponseError';
import CopyNominal from './popup-components/CopyNominal';
import TurnoverDetails from './popup-components/TurnoverDetails';
import ErrorBoundary from '../../helpers/ExceptionHandler/componentException';
import ReferralPlayerList from './popup-components/ReferralPlayerList';
import OutStandingPosition from './popup-components/OutStandingPosition';
import GameApk from './GameApk';
import ConverionRateError from './popup-components/ConverionRateError';
import TogelGameBlock from './popup-components/TogelGameBlock';
const initSetting = {
    popup_cs: null,
    default_class: null,
};

const Popup = (props) => {
    console.log("props data check ===>", props);

    const [fnSetting, setFnSetting] = useState(initSetting);

    const { componentSetting } = useSelector(state => ({
        componentSetting: state.componentSettingListR.data
    }));
    const [custComplaint, setCustComplaint] = useState(false);

    const handle = () => {
        if (!props.isReferralPlayerList) {
            props.handlePoup()
        }
    }

    const userData = () => {
        props.userDataHandle()
    }

    const changeEmailConfirm = () => {
        props.changeEmailConfirm()
    }

    const handleData = (formSuccess, data) => {
        props.handleData(formSuccess, data)
    }

    const handleErr = (err) => {
        props.handleErr(err)
    }

    const customerComplaintsClass = () => {
        setCustComplaint(true)
    }

    const handleEmailDurationPopupOn = () => {
        props.handleEmailDurationPopupOn();
    }

    const handlePopup = () => {
        props.handlePopup();
        props.handlePopupAdminPass();
    }


    const getNotificationCount = () => {
        props.getNotificationCount()
    }

    const handleNewMessageCount = () => {
        props.handleNewMessageCount();
    }

    const deleteMessageConfirm = () => {
        props.deleteMessageConfirm();
    }

    const deleteConfirmMessage = () => {
        props.deleteConfirmMessage();
    }

    const refreshInboxList = () => {
        props.refreshInboxList();
    }

    const handleMe = () => {
        props.handleMe();
    }

    const expiredPassword = () => {
        props.expiredPassword();
    }

    const handleLoginPopup = () => {
        props.handleLoginPopup();
    }
    const btnRefLogin = useRef()
    const btnRefLoginEye = useRef()
    const btnRefLoginSidebarEnter = useRef()

    useEffect(() => {
        function handler(e) {
            if (!btnRefLogin.current?.contains(e.target) && !props.RegisterWithLogin) {
                handle();
            }
        }

        const popupModel = document.getElementById("popup-model-id");

        if (popupModel) {
            popupModel.addEventListener('click', handler);
        }

        return () => {
            if (popupModel) {
                popupModel.removeEventListener('click', handler);
            }
        };
    }, []);

    const handleNotificationPopup = () => {
        handle();
    }

    useEffect(() => {
        let tmp = fnSetting;
        if (typeof componentSetting?.["popup"] != 'undefined') {
            let classDeafault = componentSetting?.["popup"]?.["default-value"];
            setFnSetting({
                ...fnSetting,
                ['default_class']: componentSetting?.["popup"]?.["default-value"],
            })
        }
    }, []);
    const handleMemoPopup = () => {
        props.handleMemoPopup();
    }


    return (
        <>
            {

                typeof componentSetting.popup != 'undefined' && componentSetting?.["popup"]?.["default-value"] &&
                <div className={`popup-modal ${fnSetting['default_class']} ${props.readNotification ? 'memo-width' : ''
                    } ${custComplaint ? 'customerComplaintsClass' : ''}`}
                    id="popup-model-id">
                    <div className="modal-cus" ref={btnRefLogin}>
                        {!props.RegisterWithLogin && <span className="close" onClick={handle}><GrFormClose /></span>}
                        {props.changePass &&
                            <ErrorBoundary>
                                <ChangePassword />
                            </ErrorBoundary>
                        }
                        {props.custComplaint &&
                            <ErrorBoundary>
                                <CustomerComplaints customerComplaintsClass={customerComplaintsClass} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.loginMobile &&
                            <ErrorBoundary>
                                <LoginMobile handle={handle} userData={userData} />
                            </ErrorBoundary>
                        }
                        {
                            props.playerstatus && <ErrorBoundary><GamePlayer handle={handle} userData={userData} /></ErrorBoundary>
                        }
                        {props.loginpopup &&
                            <ErrorBoundary>
                                <LoginPopup handle={handle} userData={userData} />
                            </ErrorBoundary>
                        }

                        {props.forgotPass &&

                            <ErrorBoundary>
                                <ForgotPassword data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.invalidEmail &&
                            <ErrorBoundary>
                                <InvalidEmail data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.changeEmail &&
                            <ErrorBoundary>
                                <ChangeEmail handleData={handleData} changeEmailConfirm={changeEmailConfirm} />
                            </ErrorBoundary>
                        }
                        {props.emailAlreadyUsed &&
                            <ErrorBoundary>
                                <EmailAlreadyUsed />
                            </ErrorBoundary>
                        }
                        {props.wrongPassword &&
                            <ErrorBoundary>
                                <ErrorMessages data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.securityQuestionChange &&
                            <ErrorBoundary>
                                <SecurityQuestionChange />
                            </ErrorBoundary>
                        }
                        {props.pinProtection &&
                            <ErrorBoundary>
                                <PinProtection data={props.data} />
                            </ErrorBoundary>
                        }
                        {props.setNewPin &&
                            <ErrorBoundary>
                                <ErrorMessages data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.agreeMessage &&
                            <ErrorBoundary>
                                <Agree handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.expiredPassword &&
                            <ErrorBoundary>
                                <ExpiredPassword handle={handle} data={props.data} />
                            </ErrorBoundary>
                        }
                        {
                            props.registerpopup &&
                            <ErrorBoundary>
                                <Register handlePoup={() => props.HandleRegisterPopup} />
                            </ErrorBoundary>
                        }
                        {props.securityValidationMessage &&

                            <ErrorBoundary>
                                <SecurityValidation handleErr={handleErr} data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.sendEmail &&
                            <ErrorBoundary>
                                <SendEmail />
                            </ErrorBoundary>
                        }
                        {props.sendEmailDuration &&
                            <ErrorBoundary>
                                <SendEmailDuration handleEmailDurationPopupOn={handleEmailDurationPopupOn} data={props.message} />
                            </ErrorBoundary>
                        }
                        {props.newMessageCount &&
                            <ErrorBoundary>
                                <NewMessageNotification handleNewMessageCount={handleNewMessageCount} data={props.count} refreshInboxList={refreshInboxList} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.deleteMessagePopup &&
                            <ErrorBoundary>
                                <ConfirmDelete handle={handle} deleteMessageConfirm={deleteMessageConfirm} deleteConfirmMessage={deleteConfirmMessage} />
                            </ErrorBoundary>
                        }
                        {props.errorMessages &&
                            <ErrorBoundary>
                                <ErrorMessages data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.successMessages &&
                            <ErrorBoundary>
                                <SuccessMessages data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {
                            props.conversionRateError &&
                            <ErrorBoundary>
                                <ConverionRateError data={props.data} handle={handle}/>
                            </ErrorBoundary>
                        
                        }
                        {props.referralMsg &&
                            <ErrorBoundary>
                                <ReferralMessage />
                            </ErrorBoundary>
                        }

                        {props.RegisterWithLogin &&
                            <ErrorBoundary>
                                <RegisterWithLogin data={props.data} handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.blockPopUpMessage &&
                            <ErrorBoundary>
                                <UserBlock handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.resultData &&
                            <ErrorBoundary>
                                <Result rowData={props.rowData} />
                            </ErrorBoundary>
                        }
                        {props.lotteryData &&
                            <ErrorBoundary>
                                <CompleteResult />
                            </ErrorBoundary>
                        }
                        {props.providerMaintainance &&
                            <ErrorBoundary>
                                <ProviderMaintenance handlePopup={handlePopup} />
                            </ErrorBoundary>
                        }
                        {props.togelGameBlock &&
                            <TogelGameBlock handlePopup={handlePopup} />
                        }
                        {props.apiresponseerror &&
                            <ErrorBoundary>
                                <ApiResponseError handlePopup={handlePopup} />
                            </ErrorBoundary>
                        }

                        {props.commingSoonGame &&
                            <ErrorBoundary>
                                <ProviderGameCommingSoon handlePopup={handlePopup} />
                            </ErrorBoundary>
                        }


                        {props.gameLunchLoginErrorPopup &&

                            <ErrorBoundary>
                                <TokenValidation handlePopup={handlePopup} />
                            </ErrorBoundary>
                        }

                        {props.globalMaintenanceCondition &&
                            <ErrorBoundary>
                                <GlobalMaintenance handlePopup={handlePopup} data={props.message} />
                            </ErrorBoundary>
                        }

                        {/* {props.resultData &&
                            <PreLogin />
                        } */}

                        {props.afterLogin &&
                            <ErrorBoundary>
                                <PostLogin handle={handle} handlePopupCheckbox={props?.handlePopupCheckbox} />
                            </ErrorBoundary>
                        }

                        {props.beforeLogin &&
                            <ErrorBoundary>
                                <PreLogin handle={handle} handlePopupCheckbox={props?.handlePopupCheckbox} />
                            </ErrorBoundary>
                        }

                        {props.DepositWithdrawMessage &&
                            <ErrorBoundary>
                                <DepositWithdrawMessage data={props.data} handleNotificationPopup={handleNotificationPopup} handle={handle} />
                            </ErrorBoundary>
                        }

                        {props.HomeScreenPopup &&
                            <ErrorBoundary>
                                <HomeScreenPopup data={props.data} handleNotificationPopup={handleNotificationPopup} handle={handle} />
                            </ErrorBoundary>
                        }

                        {props.playerRejected &&

                            <ErrorBoundary>
                                <PlayerRejected handle={handle} setNotification={props.setNotification} />
                            </ErrorBoundary>
                        }

                        {props.gameNotPlay &&
                            <ErrorBoundary>
                                <GameNotPlay handle={handle} />
                            </ErrorBoundary>
                        }

                        {
                            props.warning &&
                            <ErrorBoundary>
                                <ShowWarning handle={handlePopup} />
                            </ErrorBoundary>
                        }

                        {
                            props.success &&
                            <ErrorBoundary>
                                <ShowSuccess handle={handlePopup} />
                            </ErrorBoundary>
                        }

                        {
                            props.readData &&
                            <ErrorBoundary>
                                <TextReadMore handle={handlePopup} />
                            </ErrorBoundary>
                        }

                        {
                            props.readNotification &&
                            <ErrorBoundary>
                                <Notification handle={handlePopup} length={props.length} getNotificationCount={getNotificationCount} />
                            </ErrorBoundary>
                        }

                        {props.comingSoon &&
                            <ErrorBoundary>
                                <ComingSoon handle={handlePopup} />
                            </ErrorBoundary>
                        }

                        {props.adminPasswordChange &&
                            <ErrorBoundary>
                                <ResetAdminPassword handle={handlePopup} />
                            </ErrorBoundary>
                        }

                        {/* {props.rulesMessage &&
                            <RulesOfPlay handle={handle} />
                        } */}

                        {props.referralEmailVerification &&
                            <ErrorBoundary>
                                <ValidationMailVarification handle={handle} />
                            </ErrorBoundary>
                        }
                        {props.launchGameMessage &&
                            <ErrorBoundary>
                                <LaunchGameMessage confirmRelaunch={props.confirmRelaunch} cancelRelaunch={props.cancelRelaunch} />
                            </ErrorBoundary>
                        }
                        {props.newMemoMessage &&
                            <ErrorBoundary>
                                <NewMessageNotification handleMemoPopup={handleMemoPopup} setNotification={props.setNotification} length={props.length} getNotificationCount={getNotificationCount} />
                            </ErrorBoundary>
                        }

                        {props.copyPopup &&

                            <ErrorBoundary>
                                <CopyNominal handle={handlePopup} copyNominalText={props.copyNominalText} />
                            </ErrorBoundary>
                        }

                        {props.TurnoverPopup &&

                            <ErrorBoundary>

                                <TurnoverDetails handle={handlePopup} data={props.data} />
                            </ErrorBoundary>

                        }

                        {props.isReferralPlayerList &&
                            <ReferralPlayerList handleRefPopup={props.handleRefPopup} data={props.data} date={props.listDate} player={props.player} />
                        }

                        
                        {props.outStandBetPosition && 
                            (
                                <OutStandingPosition handle={props.handlePoup} data={props.data} dataKey={props.mobileDataKey} mobileData={props.mobileData} />
                            )
                        }

                        {
                            props.gameApk &&
                            <GameApk handle={handlePopup} />
                        }

                    </div>
                </div>
            }
        </>
    )
}

Popup.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Popup);